import { Select } from "antd";

const { Option } = Select;

const CustomSelect = ({
  label,
  value,
  placeholder,
  onChange,
  error,
  options = [],
  style,
  mode,
  required = false,
  ...rest
}) => {
  return (
    <div style={{ marginBottom: '1rem', marginRight: "1rem", ...style }}>
      {label && (
        <label style={{ fontWeight: 500, display: "block", marginBottom: 4 }}>
          {label}
          {required && <span style={{ color: "red" }}> *</span>}
        </label>
      )}
      <Select
        value={value}
        onChange={(val) => onChange(val)}
        placeholder={placeholder}
        mode={mode}
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
        style={{ width: "100%", borderColor: error ? "red" : undefined }}
        {...rest}
      >
        {options.map((option, index) => (
          <Option key={index} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
      {error && <p style={{ color: "red", marginTop: 4 }}>{error}</p>}
    </div>
  );
};

export default CustomSelect;
